export default "__VITE_ASSET__Cgl2q2rk__"